<template>
    <div>
        <div v-if="games.length">
            <router-view v-if="selectedGame" :game="selectedGame" :key="selectedGame.id" />
            <div v-if="!selectedGame" class="container bng-slots bng-narrow-container">
                <div class="bng-slots-filter">
                    <div class="columns is-gapless">
                        <div class="search column is-4">
                            <label :class="{ 'active': showSearch }" style="margin-bottom: 0.8em;">
                                <input class="input is-rounded"
                                       type="text"
                                       :placeholder="'components.common.slots-filter.seach placeholder' | translate"
                                       v-model.trim="searchText"
                                       @input="filterGames();" />
                                <a class="button is-rounded is-dark" @click="showSearch = !showSearch">
                                    <span class="icon has-text-warning">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </a>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline is-mobile bng-game-list">
                    <template v-for="batch, batchNum in batches">
                        <template v-for="game in batch">
                        <div
                            v-if="showedBatch > batchNum"
                            :key="game.id"
                            :data-batch="batchNum"
                            ref="game"
                            class="column is-6-mobile is-4-tablet is-3-desktop is-2-widescreen is-2-fullhd bng-game-list-item">
                            <router-link :to="{ name: 'softgamings-game', params: { gameId: game.id } }" class="card">
                                <div class="game-card-overlay"></div>
                                <div class="card-image">
                                    <figure class="image">
                                        <img :src="game.imageFullPath" />
                                        <figcaption class="game-detils fadeIn-bottom is-uppercase is-size-5">
                                            <h3>
                                                {{ game.names["en"] }}
                                            </h3>
                                        </figcaption>
                                    </figure>
                                </div>
                            </router-link>
                        </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <dimmer :value.sync="dimmer" />
    </div>
</template>

<script>
    import Vue from "vue";
    import dimmer from "../../../common/payments/dimmer.vue";
    import softGamingsService from "../../../../../../_common/services/softgamings.service";

    export default {
        name: "list",
        components: { dimmer },
        data: () => ({
            games: [],
            gamesFiltered: [],
            showedBatch: 2,
            selectedGame: null,
            searchText: null,
            showSearch: false,
            dimmer: null
        }),
        computed: {
            lang: function() {
                return Vue.state.lang.currentLang;
            },
            gameId: function() {
                return this.$route.params.gameId;
            },
            batches: function () {
                const result = [];
                for (let i = 0 ; i < this.gamesFiltered.length; i++) {
                    const batchNum = Math.round(i / 50);
                    if (batchNum > result.length - 1) result.push([]);
                    result[batchNum].push(this.gamesFiltered[i]);
                }
                return result;
            }
        },
        methods: {
            async loadGamesAsync() {
                try {
                    this.dimmer.show();
                    this.games.length || this.games.push(...(await softGamingsService.getGamesAsync()));
                    this.gamesFiltered = this.games;
                    this.selectedGame = this.games.find(item => item.id == this.gameId);
                }
                finally {
                    this.dimmer.hide();
                }
            },
            filterGames() {
                const searchText = this.searchText.toLowerCase();
                this.gamesFiltered = this.games.filter(item => item.names["en"].toLowerCase().indexOf(searchText) > -1);
            },
            handleBodyScroll (e) {
                var height = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                const scrollBottom = e.target.scrollingElement.scrollTop + height;
                const showedBatches = this.$refs.game
                    .filter(g => g.offsetTop < scrollBottom)
                    .map((g) => (g.attributes['data-batch'].value));
                const newShowedBatch = +(showedBatches.slice(-1)[0]) + 2;

                if (this.showedBatch < newShowedBatch) {
                    this.showedBatch = newShowedBatch;  
                }
            }
        },
        watch: {
            gameId: function() {
                this.loadGamesAsync();
                this.searchText = null;
            }
        },
        mounted() {
            document.addEventListener('scroll', this.handleBodyScroll);
            this.loadGamesAsync();
        },
        removed () {
            document.removeEventListener('scroll', this.handleBodyScroll);
        }
    };
</script>

<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/softgamings/games.vue